var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"RichText t-body",domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.translate ? _vm.$tr(_vm.content) : _vm.content))}})}
var staticRenderFns = []

export { render, staticRenderFns }